import React from 'react'
import Header from '../header'
import { Table } from 'react-bootstrap'
import Footer from '../footer/Footer'

class HiringProcess extends React.Component {
    constructor (props) {
        super(props)
    }
    render () {
        return (
            <div style={{ height: '100vh'}}>
                <Header />
                <div id="hiringProcess" className="section ">
                    <div className="container-fluid" style={{ marginTop: '4.5%', marginBottom: '4.5%'}}>
                        <h1 className="title text-center" style={{ marginTop: '4.5%' }}>
                            <span>Hiring Process</span>
                            <div className="space" />
                        </h1>
                        <h2>
                            <span>Experienced Engineers</span>
                        </h2>
                        <div>
                            <Table striped bordered hover>
                                <tbody>
                                    <tr>
                                        <td>Phone screen</td>
                                        <td>A quick 10-15 min discussion to let both the candidate &amp; us to assess a fit</td>
                                    </tr>
                                    <tr>
                                        <td>Coding Test</td>
                                        <td>A coding task, that is aimed at testing your skill/knowledge in your area. 
                                            <ul> 
                                                <li> 
                                                    Eg for UI : Build a page using React-JS with certain widgets and pull data from mock backend services
                                                </li>
                                                <li>
                                                    Eg for BackEnd : Design a database schema for a problem statement, and implement a REST API &amp; Persistent storage/retrieval for some or all of the problem. 
                                                </li>
                                                <li>
                                                    Probing questions on work previously done
                                                </li>
                                            </ul>
                                         </td>
                                    </tr> 
                                    <tr>
                                        <td>Managerial &amp; HR Discussion
                                        </td>
                                        <td> 
                                            <ul>
                                                <li>Evaluate team fit</li>
                                                <li>Career plan alignment</li>
                                                <li>Horoscope matching</li>
                                                <li>Whether you like our wall colors (it's all white, btw)</li>
                                                <li>Salary nego-shi-ye-shaans!</li>  
                                            </ul>
                                        </td>
                                    </tr>                                   
                                </tbody>
                            </Table>                            
                        </div>
                        
                        <hr></hr>
                        <h2>
                            <span>Freshers</span>
                        </h2>
                        <p className="boldText">Total:  72 or <span className="text-colored">105 (Data Science only) </span>marks </p>
                        <div>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Round</th>
                                        <th>Marks</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Aptitude</td>
                                        <td className="place-right">33</td>
                                        <td>The questions are aimed at checking logical reasoning, and exploratory reasoning when there is insufficient data.</td>
                                    </tr>
                                    <tr>
                                        <td>Coding</td>
                                        <td className="place-right">29</td>
                                        <td>Questions asking you to code small snippets, or read snippets and predict the output. Any coding language is ok, syntax errors are fine. Majority of the questions do not require more knowledge than branching &amp; looping. A few questions might test Object Oriented Programming concepts.</td>
                                    </tr>
                                    <tr className="text-colored">
                                        <td>Data Science</td>
                                        <td className="place-right">33</td>
                                        <td>This will be held if you are applying for a data science position. Data Science related math/stat questions, basic questions around linear/logistic regression, etc.</td>
                                    </tr>
                                    <tr>
                                        <td>Attitude</td>
                                        <td className="place-right">05</td>
                                        <td>! ( candidate.growls() || candidate.barks() || candidate.bites() )</td>
                                    </tr>
                                    <tr>
                                        <td>Punctuality</td>
                                        <td className="place-right">05</td>
                                        <td> ( candidate.arrivalTime &lt;= interview.startTime ) </td>
                                    </tr>
                                    <tr>
                                        <td className="boldText">Total</td>
                                        <td className="place-right boldText">72
                                            (or<span className="text-colored"> 105</span>)
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Managerial</td>
                                        <td colSpan="2">This is our CEO trying to sound funny. Make sure to laugh loudly at his not-so-funny jokes! </td>
                                    </tr>
                                    <tr>
                                        <td>HR Discussion</td>
                                        <td colSpan="2">Be ready for the 'Where do you see yourself in 25 years?' kind of questions! But don't worry - even answers like 'Hopefully not in HR' will be accepted with a laugh!</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3">
                                            <p className="boldText" style={{fontStyle: "italic"}}>Note:</p>
                                            <ul>
                                                <li>Logical round performance will matter most for Non-CS candidates.</li>
                                                <li>CS/IT/IS stream candidates that do badly in the coding round will not go further despite stellar performance in other areas.</li>
                                                <li>Typically,  scores below 45/72 or <span className="text-colored">70/105</span> will not be considered for the next round</li>
                                            </ul>
                                            <p className="boldText" style={{fontStyle: "italic"}}>Extra Note:</p>
                                            <ul>
                                                <li>If that growl/bark/bite condition made you smile, we're already great minds thinking alike</li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>   
                </div>
                <div>
                    <Footer />
                </div>
            </div>  
        )
    }
}

export default HiringProcess


// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/careers/hiringProcess.js